import { ContentNotice } from './ContentNotice';

/**
 * Aviso de questão anulada, no topo do body. Era uma linha de texto colorido,
 * fácil de passar batido justo na informação que muda a leitura da questão.
 * Sem `role="status"`: o aviso existe ao montar, e `status` só anuncia mudança.
 */
export function AnnulledNotice() {
  return (
    <ContentNotice>
      Questão anulada — não há alternativa correta a considerar.
    </ContentNotice>
  );
}
